import { Component, Input, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { forkJoin, of, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { CatEmployeeJobModel } from 'src/app/model/cat-employee-job.model';
import { CatFeeEmployeejobModel } from 'src/app/model/cat-fee-employee-job-model';
import { ComGoalEmployeeJobModel } from 'src/app/model/com-goal-employee-job.model';
import { CatalogModel } from 'src/app/model/other-catalogs-models';
import { CatEmployeeJobService } from 'src/app/services/cat-employee-job.service';
import { CatFeeEmployeeJobService } from 'src/oldApp/services/cat-fee-employee-job.service';
import { ComGoalEmployeeJobService } from 'src/oldApp/services/com-goal-employee-job.service';

@Component({
  selector: 'app-modal-sc-goal-employee-job',
  templateUrl: './modal-sc-goal-employee-job.component.html',
  styleUrls: ['./modal-sc-goal-employee-job.component.css']
})
export class ModalScGoalEmployeeJobComponent implements OnInit {
  @Input() goal:ComGoalEmployeeJobModel;
  @Input() page:string;
  @Input() mode:string;
  @Input() goals:ComGoalEmployeeJobModel[]=[];

  // estado pagina
  public viewStatus:number=1;
  public formIsLocked:boolean=false;

  // catalogos
  public employeeJobCatalog:CatalogModel[]=[];
  public feeEmployeeJobCatalog:CatFeeEmployeejobModel[]=[];
  public feeEmployeeJobSubCatalog:CatFeeEmployeejobModel[]=[];

  // mascaras
  public customPatterns={
    'A':{pattern:new RegExp('[a-zA-Z0-9ñÑ ]')},                     // inputs regulares
    'C':{pattern:new RegExp('[a-zA-Z0-9áéíóúÁÉÍÓÚüÜñÑ,._:%\/() \-]')},       // comentarios (acepta acentos, comas y puntos)
    'N':{pattern:new RegExp('[0-9]')} 
  };

  /////////////////
  constructor(
    private comGoalEmployeeJobService:ComGoalEmployeeJobService,
    private catEmployeeJobService:CatEmployeeJobService,
    private catFeeEmployeeJobService:CatFeeEmployeeJobService,
    private modalService: NgbModal,
    private toastr:ToastrService
  ) { }
  ngOnInit() {
    this.getCatalogs();
  }

  //
  toggleCoordinatorManage=()=> this.goal.coordinatorManage=!this.goal.coordinatorManage;
  updateEmployeeJob=()=> {
    if(this.goal.employeeJobId === 7){
      this.feeEmployeeJobSubCatalog=this.feeEmployeeJobCatalog.filter(fee=> fee.employeeJobId===this.goal.employeeJobId);
    }else{
      let option = new CatFeeEmployeejobModel();
          option.feeEmployeeJobId = 0;
          option.description = "N/A";
      this.feeEmployeeJobSubCatalog.push(option);
    }
  }
  updateFeeEmployeeJob=()=> {
  }
  updateMinGoal=e=> this.goal.minGoal=Number(e);
  updateMaxGoal=e=> this.goal.maxGoal=Number(e);
  updateCommission=e=> this.goal.commission=Number(e);
  toggleActive=()=> this.goal.activeId=!this.goal.activeId;
  isValid=()=> {
    let valid=true;
    let errors=[];
    if(this.employeeJobError()) errors.push('Necesita seleccionar un puesto.');
    //if(this.feeEmployeeJobError()) errors.push('Necesita capturar una cuota.');
    if(this.minGoalError()) errors.push('Necesita capturar una meta mínima.');
    if(this.maxGoalError()) errors.push('Necesita capturar una meta máxima.');
    if(this.validateMinMaxGoal()) errors.push('Necesita capturar una meta máxima mayor a la meta mínima.');
    if(this.existsError()) errors.push('La meta seleccionada, ya existe!');
    if(this.commissionError()) errors.push('Necesita capturar una comisión.');
    if(errors.length>0) {
      valid=false;
      this.toastr.error(errors.join('<br>'), '¡Atención!', {enableHtml:true});
    }
    return valid;
  }
  save=()=> {
    if(this.isValid()) {
      // mostrar spinner
      this.viewStatus=0;
      // enviar informacion
      this.comGoalEmployeeJobService.save(this.goal)
        .pipe(
          tap((resp:any)=> {
            console.log(resp);
            this.modalService.dismissAll('success');
            this.toastr.success('La categoría se guardó con éxito.');
          }),
          catchError(error=> {
            console.log(error);
            this.modalService.dismissAll('failure');
            return of(this.toastr.error('Ocurrió un error al intentar guardar la categoría.'));
          })
        )
        .subscribe();
    }
  }
  close=()=> this.modalService.dismissAll();

  // HELPERS
  employeeJobError=()=> !this.goal.employeeJobId;
  feeEmployeeJobError=()=> this.feeEmployeeJobSubCatalog.length>0 && (!this.goal.feeEmployeeJobId);
  minGoalError=()=> this.goal.minGoal==0|| !this.goal.minGoal;
  maxGoalError=()=> this.goal.maxGoal==0|| !this.goal.maxGoal;
  commissionError=()=> this.goal.commission==0|| !this.goal.commission;
  validateMinMaxGoal=()=> this.goal.maxGoal<this.goal.minGoal;
  existsError=()=>{
    let exists = false;
    // let goalsFiltered = this.goals.filter(ca => ca.commissionProductCategoryId !== this.goal.commissionProductCategoryId);
    // goalsFiltered.forEach((ca)=>{
    //   if(ca.productCategoryId === this.goal.productCategoryId &&
    //      ca.employeeJobId === this.goal.employeeJobId &&
    //      ca.paymentId === this.goal.paymentId &&
    //      ca.activeId === this.goal.activeId)
    //     exists = true;
    // });
    return exists;
  }
  
  // INFO
  getCatalogs=()=> {
    forkJoin(
      this.catEmployeeJobService.catalog(),
      this.catFeeEmployeeJobService.getAll()
    )
    .pipe(
      tap(([empJobResp, feeEmpResp]:[any,any])=> {
        if(empJobResp && feeEmpResp) {
          this.employeeJobCatalog=empJobResp.data;
          this.feeEmployeeJobCatalog=feeEmpResp.data;
          this.viewStatus=1;
          console.log(">> this.feeEmployeeJobCatalog= ", this.feeEmployeeJobCatalog);
          if(this.mode === "edit"){
            this.updateEmployeeJob();
          }
        }
        else throwError;
      }),
      catchError(error=> {
        console.log(error);
        this.viewStatus=-1;
        return of(this.toastr.error('Ocurrió un error al leer los catálogos.'));
      })
    )
    .subscribe();
  }
}